import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#cascader" }),
    /*#__PURE__*/_createTextVNode(" Cascader ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " If the options have a clear hierarchical structure, Cascader can be used to view and select them. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIDisabledOption = _resolveComponent("EUIDisabledOption")
  const _component_EUIClearable = _resolveComponent("EUIClearable")
  const _component_EUIDisplayOnlyTheLastLevel = _resolveComponent("EUIDisplayOnlyTheLastLevel")
  const _component_EUIMultipleSelection = _resolveComponent("EUIMultipleSelection")
  const _component_EUISelectAnyLevelOfOptions = _resolveComponent("EUISelectAnyLevelOfOptions")
  const _component_EUIDynamicLoading = _resolveComponent("EUIDynamicLoading")
  const _component_EUIFilterable = _resolveComponent("EUIFilterable")
  const _component_EUICustomOptionContent = _resolveComponent("EUICustomOptionContent")
  const _component_EUICascaderPanel = _resolveComponent("EUICascaderPanel")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIDisabledOption),
    _createVNode(_component_EUIClearable),
    _createVNode(_component_EUIDisplayOnlyTheLastLevel),
    _createVNode(_component_EUIMultipleSelection),
    _createVNode(_component_EUISelectAnyLevelOfOptions),
    _createVNode(_component_EUIDynamicLoading),
    _createVNode(_component_EUIFilterable),
    _createVNode(_component_EUICustomOptionContent),
    _createVNode(_component_EUICascaderPanel)
  ], 64))
}